import { useEffect } from "react";

const Oauth = () => {
  useEffect(() => {
    window.location.href =
      "https://its.iust.ac.ir/oauth2/authorize?grant_type=authorization_code&redirect_uri=https://adminapply.iust.ac.ir/&client_id=apply&client_secret=apS764gtys&scope=openid%20profile%20picurl&response_type=token&state=token";
  }, []);
  return <></>;
};

export default Oauth;
